var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM11.36 6.64L7.52 10.48C7.2 10.8 6.72 10.8 6.4 10.48L4.64 8.72C4.32 8.4 4.32 7.92 4.64 7.6C4.96 7.28 5.44 7.28 5.76 7.6L6.96 8.8L10.24 5.52C10.56 5.2 11.04 5.2 11.36 5.52C11.68 5.84 11.68 6.32 11.36 6.64Z",
    fill: "#4A3A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.98fe31c74d48efcff31e5edfeeddd3b8.svg";
export { ForwardRef as ReactComponent };